import React, { useEffect, useState } from "react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Heart, Crown } from "lucide-react";
import { Link } from "react-router-dom";

/** Compact daily-likes counter shown in Discover header. */
const LikeQuota = ({ refreshKey = 0 }) => {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await client.get("/like-quota");
        if (mounted) setData(r.data);
      } catch { /* noop */ }
    })();
    return () => { mounted = false; };
  }, [refreshKey, user?.id]);

  if (!data) return null;
  if (data.is_premium) {
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#C5A880]/10 border border-[#C5A880]/40 text-[#C5A880] text-xs"
        data-testid="like-quota-premium">
        <Crown className="w-3.5 h-3.5" /> Likes ilimitados
      </span>
    );
  }
  const remaining = data.remaining ?? 0;
  const exhausted = remaining === 0;
  return (
    <Link to="/premium"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs transition-colors ${
        exhausted
          ? "bg-[#7A2021]/10 border border-[#7A2021]/40 text-[#E37B7B]"
          : "bg-white/5 border border-white/15 text-[#DCD7D2] hover:border-[#C5A880]/40"
      }`}
      data-testid="like-quota-free">
      <Heart className="w-3.5 h-3.5" />
      {exhausted ? "Sem likes hoje · " : `${remaining} likes hoje · `}
      <span className="text-[#C5A880]">Premium para ilimitar</span>
    </Link>
  );
};

export default LikeQuota;
